// Pacific Crest Properties - Site Data

export const siteConfig = {
  name: "Pacific Crest Properties",
  slogan: "From Coast to Crest",
  sloganLine2: "Real Estate Elevated",
  phone: "(310) 596-6534",
  email: "office@pacificcrestprop.com",
  address: {
    street: "732 South 6th Street, STE N",
    city: "Las Vegas",
    state: "NV",
    zip: "89101"
  },
  links: {
    offers: "/sell-your-home",
    renovations: "/renovation"
  }
};

export const navItems = [
  { label: "Home", href: "/", isAnchor: false },
  { label: "Services", href: "/services", isAnchor: false },
  { label: "Locations", href: "/locations", isAnchor: false },
  { label: "Contact", href: "/contact", isAnchor: false }
];

export const services = {
  offers: {
    title: "Fast, No-Hassle Property Offers",
    description: "Looking to sell quickly without the traditional hassle? We provide straightforward, as-is property purchases with flexible closing timelines.",
    features: [
      "We buy properties as-is",
      "No repairs, no agents, no lengthy listings",
      "Flexible closing timelines",
      "Simple, direct, transparent process"
    ],
    cta: {
      text: "Get an Offer",
      href: "/sell-your-home#get-offer"
    }
  },
  renovation: {
    title: "Renovation & Home Improvement Services",
    description: "Transform your property with our comprehensive renovation services. From kitchen remodels to complete home makeovers, we deliver quality craftsmanship.",
    features: [
      "Modern upgrades",
      "Kitchen & bathroom remodels",
      "Flooring, painting, exterior improvements",
      "Transparent, itemized pricing",
      "Licensed and insured contractor partners"
    ],
    cta: {
      text: "Get a Renovation Quote",
      href: "/renovation#get-quote"
    }
  }
};

export const processSteps = [
  {
    step: 1,
    title: "Tell Us About Your Property or Project",
    description: "Simple intake form depending on your needs."
  },
  {
    step: 2,
    title: "Receive a Personalized Plan",
    description: "Either a fair cash offer or a detailed renovation quote."
  },
  {
    step: 3,
    title: "Move Forward With Confidence",
    description: "Choose the path that fits your timeline and goals."
  }
];

export const aboutContent = {
  title: "About Pacific Crest Properties",
  paragraphs: [
    "Pacific Crest Properties helps homeowners across Los Angeles make confident real estate decisions — whether they're looking to sell quickly, improve their home's condition, or explore renovation options.",
    "We provide straightforward solutions tailored to your goals, offering both as-is property offers and high-quality renovation services. Our mission is to make each step clear, transparent, and stress-free."
  ]
};

export const footerPrivacy = "Pacific Crest Properties respects your privacy. We do not sell, rent, or share personal data collected through our forms or text communications.";

export const footerDisclaimer = '"All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties."';
